import { createContext } from 'react';

const CodeOperationsContext = createContext({
  onExcerptSelected: () => {},
  onNewCode: () => {},
  addCodeToExcerpt: () => {},
  onRemoveCode: () => {},
  isCreatingExcerpt: false,
  isAddingCode: false,
  isRemovingCode: false,
});

export default CodeOperationsContext;
